/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter, getFormattedForeignCurrency } from '../../../../utils/formatting';

function ForeignCurrency({
 tenderInfo, foreignCurrency
}) {
  const {
    locale: { storeCurrency, storeLocale }, RL_ExchangeRate
  } = useSelector((state) => state);
    // Get the locale based on currency code
    const formattedForeignCurrency = getFormattedForeignCurrency(foreignCurrency, storeLocale);

  return (
    <>
      <article className="justify-between">
        <p>
          {foreignCurrency.OriginalFaceAmount?.Currency}
          &nbsp;
          {formattedForeignCurrency}
        </p>
      </article>
      <article className="justify-between">
        <p>
          {' '}
          &nbsp;&nbsp;&nbsp;{RL_ExchangeRate} &nbsp;
          {foreignCurrency?.ExchangeRate}
        </p>
        <p>
          {currencyFormatter(
            storeLocale,
            storeCurrency,
            tenderInfo.Tender?.Amount?.Amount
          )}
        </p>
      </article>
    </>
  );
}

ForeignCurrency.propTypes = {
  foreignCurrency: PropTypes.shape().isRequired,
  tenderInfo: PropTypes.shape().isRequired,
};

export default ForeignCurrency;
